import { generateFullPath } from "../utils/helpers";

const config = (command, S3args) => {
  const params = {
    s3: {
      command: command,
      args: {
        Bucket: process.env.VUE_APP_BUCKET_NAME,
      },
    },
  };

  Object.assign(params.s3.args, S3args);

  const url = generateFullPath("/api/s3middleware");

  return [url, params];
};

export default config;
